import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UuidService {

  private uuidKey = 'tenantUUID';
  private defaultExpireDays = 7; // Default expiration time in days

  constructor() { }

  /**
   * Generate UUID v4 RFC4122 compliant
   */
  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  /**
   * Store a value with expiration (days)
   */
  setWithExpiry(value: string, days: number = this.defaultExpireDays): void {
    const now = new Date();
    const item = {
      value: value,
      expiry: now.getTime() + days * 24 * 60 * 60 * 1000,
    };
    localStorage.setItem(this.uuidKey, JSON.stringify(item));
  }

  /**
   * Get value if not expired, otherwise returns null
   */
  getWithExpiry(): string | null {
    const itemStr = localStorage.getItem(this.uuidKey);
    if (!itemStr) {
      return null;
    }
    try {
      const item = JSON.parse(itemStr);
      const now = new Date();
      if (now.getTime() > item.expiry) {
        localStorage.removeItem(this.uuidKey);
        return null;
      }
      return item.value;
    } catch {
      localStorage.removeItem(this.uuidKey);
      return null;
    }
  }

  /**
   * Retrieves existing UUID or creates one and stores with expiration
   */
  getOrCreateUUID(expireDays?: number): string {
    let uuid = this.getWithExpiry();
    if (!uuid) {
      uuid = this.generateUUID();
      this.setWithExpiry(uuid, expireDays ?? this.defaultExpireDays);
    }
    return uuid;
  }

  /**
   * Allows changing the default expiration duration in days
   */
  setDefaultExpirationDays(days: number): void {
    this.defaultExpireDays = days;
  }
}
